import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import Owner from '../tract_detail/Owner';
import IOwner from '../IOwner';
import WIContractOwnership from '../tract_detail/WIContractOwnership';
import ContractGenerationOwnerData from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationOwnerData';
import ContractAdHocClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAdHocClause';
import ContractAmendment from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAmendment';
import Acknowledgement from '../leasing/Acknowledgement';
import ContractAddendumClauseXRef from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClauseXRef';
import IContract from './IContract';

export default class BatteryStorage implements IContract {
    id: number;
    contractName: string;
    dlcLeaseNumber: number;
    leaseDate?: Date;
    effectiveDate?: Date;
    volume: string;
    page: string;
    instrumentNumber: string;
    fedStateLeaseNumber: string;
    isFiledByMemo?: boolean;
    originalGrossAcres?: number;
    leasedBy: string;
    lesseeName: string;
    lesseeAddressLine1: string;
    lesseeAddressLine2: string;
    lesseeCity: string;
    lesseeState: string;
    lesseeZipCode: string;
    lesseePhoneNumber: string;
    lesseeOwnerLookupId?: number;
    originalLessee: string;
    isNotOriginalLessee?: boolean;
    lessorAka: string;
    createdDate?: Date;
    isCommitted?: boolean;
    commitDate?: Date;
    inHandDate?: Date;
    isInHand?: boolean;
    voidDate?: Date;
    isVoid?: boolean;
    createdByUserId?: number;
    leasedByUserId?: number;
    recordDate?: Date;
    recordTypeId?: number;
    projectId?: number;
    isGeneratedLease?: boolean;
    isActive?: boolean;
    legalDescription: string;
    rteLegalDescription: string;
    leaseLessorNotes: string;
    bonusAmount?: number;
    bonusTypeId?: number;
    clientDocNumber: string;
    reminderDate?: Date;
    reminderNote: string;
    ownersOnDocument: string;
    ownersAddressOnDocument: string;
    ownersSSNTaxIdOnDocument: string;
    recordedDate?: Date;

    // not mapped
    invoiceableLookupId?: number;

    currentHold?: BatteryStorageHold;
    batteryStorageHolds?: Array<BatteryStorageHold>;

    adHocClauses?: Array<ContractAdHocClause>;
    removeAdHoc?: Array<number>;
    contractClauses?: Array<ContractAddendumClauseXRef>;
    contractAmendments?: Array<ContractAmendment>;
    acknowledgements?: Array<Acknowledgement>;

    tracts?: Array<ContractGenerationTractDetail>;
    owners?: Array<ContractGenerationOwnerData>;
}

export class BatteryStorageHold {
    id: number;
    batteryStorageId?: number;
    batteryStorageHoldNumber?: number;
    executionBonus?: number;
    executionBonusTypeId?: number;
    constructionPeriod?: boolean;
    constructionFee?: number;
    constructionFeeTypeId?: number;
    constructionDetails: string;
    constructionExtensionPeriod?: boolean;
    constructionExtensionFee?: number;
    constructionExtensionFeeTypeId?: number;
    constructionExtensionDetails: string;
    accessEasement?: boolean;
    accessFee?: number;
    accessFeeTypeId?: number;
    accessWidth?: number;
    accessWidthTypeId?: number;
    accessDetails: string;
    transmissionEasement?: boolean;
    transmissionFee?: number;
    transmissionFeeTypeId?: number;
    transmissionWidth?: number;
    transmissionWidthTypeId?: number;
    transmissionDetails: string;
    temporaryUseAreas?: boolean;
    temporaryUseFee?: number;
    temporaryUseFeeTypeId?: number;
    temporaryUseDetails: string;
    cropBuyout?: boolean;
    cropBuyoutFee?: number;
    cropBuyoutFeeTypeId?: number;
    cropBuyoutDetails: string;
    developmentPeriod?: boolean;
    developmentPeriodTerm?: number;
    developmentPeriodTermTypeId?: number;
    developmentRentAmount?: number;
    developmentRentTermTypeId?: number;
    developmentPeriodExtension?: boolean;
    developmentPeriodExtensionTerm?: number;
    developmentPeriodExtensionTermTypeId?: number;
    firstExtensionOptionRentAmount?: number;
    firstExtensionOptionRentTermTypeId?: number;
    prepaidOption?: boolean;
    developmentPeriodSecondExtension?: boolean;
    developmentPeriodSecondExtensionTerm?: number;
    developmentPeriodSecondExtensionTermTypeId?: number;
    secondExtensionOptionRentAmount?: number;
    secondExtensionOptionRentTermTypeId?: number;
    additionalExtensionOptions?: boolean;
    operationsPeriod?: boolean;
    operationsPeriodTerm?: number;
    operationsPeriodTermTypeId?: number;
    operationsBaseRentAmount?: number;
    operationsBaseRentTermTypeId?: number;
    annualEscalationRate?: number;
    escalationAbovePrime?: boolean;
    overdueRateTerm?: number;
    overdueAbovePrime?: boolean;
    extendedOperationsPeriod?: boolean;
    extendedOperationsPeriodTerm?: number;
    extendedOperationsPeriodTermTypeId?: number;
    extendedOperationsRentAmount?: number;
    extendedOperationsRentTermTypeId?: number;
    substationArea?: boolean;
    substationAcres?: number;
    substationFee?: number;
    substationFeeTypeId?: number;
    substationDetails: string;
    restorationPeriod?: boolean;
    restorationTerm?: number;
    restorationTermTypeId?: number;
    restorationTermRentAmount?: number;
    restorationTermRentTypeId?: number;
    facility?: boolean;
    facilityFee?: number;
    facilityFeeTypeId?: number;
    facilityDetails: string;
    additionalPayments?: number;
    rightsToAssign?: boolean;
    isActive?: boolean;
    isHistorical?: boolean;

    // not mapped
    totalBonusPaid: number;
    executionBonusTotal?: number;
    substationFeeTotal?: number;
    wiOwners?: Array<Owner>;
    contractOwnerships?: Array<WIContractOwnership>;
    surfaceOwner: IOwner;
    ownershipId?: number;
    contractLookupId?: number;
    sourceWaiverHoldId?: number;
}



// WEBPACK FOOTER //
// ./src/models/contract_types/BatteryStorage.ts